import React from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectOngoingQueueCallAnsweredTime } from 'flow/selectors/queue-selectors';
import { CallRecordKey } from 'flow/types/EntityKeys';

import CallBadgeWithTime from 'flow/components/ui-components/CallBadgeWithTime';
import Icon from 'flow/components/ui-components/Icon';

type Props = {
    ongoingQueueCallKey: CallRecordKey;
};

const SectionHeaderOngoingCall = ({ ongoingQueueCallKey }: Props) => {
    const { i18next } = useAppContext();

    const answeredTime = useAppSelector((state) =>
        selectOngoingQueueCallAnsweredTime(state, ongoingQueueCallKey),
    );

    // No fallback to the timestamp when the answered time is missing, unlike
    // the sibling queue-position header: the timestamp includes queue time.
    // answeredTime comes from TOP's AnsweredTime, which is absent for calls
    // that were already ongoing when TOP itself (re)connected to Asterisk.
    // The badge alone still says there is a live call.
    return (
        <CallBadgeWithTime
            badge={<Icon iconKey="phone_in_talk" size="1rem" />}
            since={answeredTime}
            label={i18next.t('call.ongoing')}
        />
    );
};

export default React.memo(SectionHeaderOngoingCall);
